import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, NgZone, OnInit, ChangeDetectionStrategy, inject, viewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import {
  MealKitButtonComponent,
  MealKitIconButtonComponent,
  MealKitProfileCardComponent,
  ProfileDescriptor,
} from '@yoni/mealcomponents-lib';
import {
  AuthService,
  User,
  UserChildren,
  Wallet,
} from '../../Services/auth.service';
import { ModalService } from '../../Services/modal.service';
import {
  QdmService,
  Restaurant,
  ServiceItem,
} from '../../Services/qdm.service';
import { Subscription } from 'rxjs';
import { CartService } from 'app/Cart/CartService';
import { PipeNumberFormat } from '../Pipes/PipeNumberFormat';
import { ModalCommandsHistoryComponent } from '../Modal/ModalCommandsHistory/ModalCommandsHistory.component';
import { ModalReloadWalletComponent } from '../Modal/ModalReloadWallet/ModalReloadWallet.component';
import { ToastrService } from 'ngx-toastr';
import { ModalPreferencesComponent } from '../Modal/ModalPreferences/ModalPreferences.component';
import {
  Enterprise,
  EnterpriseResponse,
  FullAdmissionsData,
} from '../../Services/gestion.service';
import { ResponsiveService } from '../../Services/responsive.service';
import { EnvLoader } from '../../Environment/EnvLoader';
import { ModalInformationMessage } from '../Modal/ModalInformationMessage/ModalInformationMessage';

@Component({
    imports: [
        TranslateModule,
        CommonModule,
        MealKitButtonComponent,
        MealKitProfileCardComponent,
        PipeNumberFormat,
        MealKitIconButtonComponent,
    ],
    selector: 'navigation-header',
    templateUrl: 'navigation-header.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['navigation-header.component.scss']
})
export class NavigationHeaderComponent implements OnInit, AfterViewInit {
  private qdmService = inject(QdmService);
  private auth = inject(AuthService);
  protected router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  private modal = inject(ModalService);
  private cart = inject(CartService);
  private toast = inject(ToastrService);
  private responsive = inject(ResponsiveService);

  selectedRestaurant: Restaurant | undefined = undefined;
  selectedDate: Date | undefined = undefined;

  isLogged: boolean = false;

  subscription: Subscription = new Subscription();

  currentService: ServiceItem | undefined = undefined;
  currentChild: UserChildren | null = null;
  currentUser: User | undefined = undefined;

  profileDescriptor: ProfileDescriptor | null = null;

  profileDrodownHtml: string = ``;

  public wallet: Wallet | null = null;

  readonly desktopProfile = viewChild('desktopProfile', { read: ElementRef });
  readonly mobileProfile = viewChild('mobileProfile', { read: ElementRef });
  protected cartTotal: number = 0;
  private admission: FullAdmissionsData | null = null;
  private groupOrderQty: number = 1;
  protected entData: EnterpriseResponse | null = null;
  isMobileCartShowed: boolean = false;
  cartCount: number = 0;
  protected message: string = '';
  protected selectedEnterprise: Enterprise | undefined = undefined;
  protected restaurants: Restaurant[] = [];

  protected moments: Enterprise[] = [];

  ngOnInit() {
    this.subscription.add(
      this.auth.user$.subscribe((user) => {
        this.currentUser = user;
        this.cdr.detectChanges();
        this.setProfileDropdownHtml();
      })
    );

    this.subscription.add(
      this.qdmService.restaurants$.subscribe((restaurants) => {
        this.restaurants = restaurants;
        this.cdr.detectChanges();
      })
    );

    this.subscription.add(
      this.qdmService.selectedEnterprise$.subscribe((ent) => {
        this.selectedEnterprise = ent;
        this.cdr.detectChanges();
        this.setProfileDropdownHtml();
      })
    );

    this.subscription.add(
      this.responsive.isMobileCartShowed$.subscribe((isShown) => {
        this.isMobileCartShowed = isShown;
        this.cdr.detectChanges();
        this.setProfileDropdownHtml();
      })
    );

    this.subscription.add(
      this.qdmService.selectedRestaurant$.subscribe((restaurant) => {
        this.selectedRestaurant = restaurant;
        this.cdr.detectChanges();

        if (this.selectedRestaurant) {
          this.qdmService
            .fetchRestaurantById(this.selectedRestaurant!.id)
            .then((res) => {
              this.message = (res as any).message || '';
            });
        }

        this.setProfileDropdownHtml();
        this.refreshCartTotal();
        this.clickListeners();
      })
    );

    this.subscription.add(
      this.qdmService.currentService$.subscribe((service) => {
        this.currentService = service;
        this.cdr.detectChanges();
        this.setProfileDropdownHtml();
        this.clickListeners();
        this.refreshCartTotal();
      })
    );

    this.subscription.add(
      this.qdmService.groupOrderQuantity$.subscribe((qty) => {
        this.groupOrderQty = qty;
        this.cdr.detectChanges();
        this.setProfileDropdownHtml();
      })
    );
    this.subscription.add(
      this.cart.cart$.subscribe((cart) => {
        this.setProfileDropdownHtml();
        this.refreshCartTotal();
        this.cdr.detectChanges();
      })
    );
    this.subscription.add(
      this.qdmService.selectChild$.subscribe((child) => {
        this.currentChild = child;
        this.setProfileDropdownHtml();
        this.clickListeners();
        this.refreshCartTotal();
      })
    );

    this.subscription.add(
      this.qdmService.selectedDate$.subscribe((date) => {
        this.selectedDate = date;
        this.cdr.detectChanges();
        this.setProfileDropdownHtml();
        this.clickListeners();
        this.refreshCartTotal();
      })
    );

    this.subscription.add(
      this.auth.userEnterprise$.subscribe((ent) => {
        this.entData = ent;
        this.cdr.detectChanges();
        this.setProfileDropdownHtml();

        if(this.entData && this.selectedRestaurant){
          this.moments = this.entData.enterprises.filter(
            (e) => parseInt(e.companies[0].reference) === this.selectedRestaurant!.id
          );
        }else{
          this.moments = [];
        }
      })
    );
    this.subscription.add(
      this.auth.isLogged$.subscribe((isLogged) => {
        this.isLogged = isLogged;
        this.cdr.detectChanges();
        this.setProfileDropdownHtml();
        this.clickListeners();
      })
    );

    this.subscription.add(
      this.auth.user$.subscribe((user) => {
        if (user) {
          this.profileDescriptor = {
            avatarUrl: `https://ui-avatars.com/api/?name=${user.firstname}+${user.lastname}&background=random&color=fff`,
            firstName: user.firstname,
            lastName: user.lastname,
          };

          this.wallet = user.wallet;
          this.cdr.detectChanges();
        }
      })
    );

    this.subscription.add(
      this.qdmService.selectedAdmission$.subscribe((admission) => {
        this.admission = admission;
        this.refreshCartTotal();

        this.cdr.detectChanges();
      })
    );
  }

  formatBuildDate(date?: string) {
    if (!date || date === '') {
      return 'Jamais (dev-server)';
    }

    const d = new Date(date);

    return d.formatDate('day') + ' ' + d.toLocaleTimeString('fr-FR');
  }

  formatLastPipeline(pipeline?: string) {
    if (!pipeline || pipeline === '') {
      return 'Jamais (dev-server)';
    }

    return pipeline;
  }

  setProfileDropdownHtml() {
    const env = EnvLoader.load();
    const forgetPassword = `${env.boGestionUrl}/reset-password`;

    this.profileDrodownHtml = `
    <div class="bg-noir-2 w-full py-3 pb-1 font-medium flex items-center px-4 gap-2">
        <span class="material-icons fg-gris-1">
            mail
        </span>
      <span>${this.currentUser?.email}</span>
    </div>
    <div class="bg-noir-2 w-full py-3 pt-1 font-medium flex items-center px-4 gap-2 border-b border-noir-2-contour">
        <span class="material-icons fg-gris-1">
            apartment
        </span>
      <span>${this.selectedEnterprise?.name || 'Aucune Entreprise'}</span>
    </div>`;

    if (this.selectedEnterprise && this.selectedEnterprise.isAcceptPayment) {
      this.profileDrodownHtml += `<a [routerLink]="" class="credit w-full flex items-center gap-2 p-2 pl-4 text-blue-400 bg-noir-2 hover:bg-noir-2-contour">
    <span class="material-icons">
      euro
      </span>
      <span class="font-semibold">Créditer le portefeuille</span>
    </a>
     `;
    }

    if (this.currentChild) {
      this.profileDrodownHtml += `
      <hr class="border border-noir-2-contour">
    <p class="select-none w-full text-center flex justify-center items-center gap-2 pt-2 bg-noir-2 mb-0 px-2">
    <span class="material-icons text-md">
      account_circle
      </span>
      <span class="uppercase text-xs font-semibold text-center block">
      Gestion de l'enfant <br/>
      <span class="normal-case fg-gris-2">
          ${this.currentChild?.firstname} ${this.currentChild?.lastname}
      </span>
      </span>
      </p>
      <p class="w-full text-center gap-2 bg-noir-2 mt-0 pt-0 pb-2">
    </p>

    <a [routerLink]="" class="select-none childPref w-full flex items-center gap-2 p-2 pl-4 text-white bg-noir-2 hover:bg-noir-2-contour">
    <span class="material-icons">
      settings
      </span>
      <span class="font-semibold">Préferences de l'enfant</span>
      </a>
      `;
    } else {
      this.profileDrodownHtml += `
       <a [routerLink]="" class="select-none childPref w-full flex items-center gap-2 p-2 pl-4 text-white bg-noir-2 hover:bg-noir-2-contour">
    <span class="material-icons">
      settings
      </span>
      <span class="font-semibold">Mes préferencess</span>
      </a>`;
    }

    if (this.currentUser) {
      this.profileDrodownHtml += `    <a [routerLink]="${forgetPassword}" href="${forgetPassword}" class="w-full flex items-center gap-2 p-2 pl-4 text-blue-400 bg-noir-2 hover:bg-noir-2-contour">
    <span class="material-icons">
      lock
      </span>
      <span class="font-semibold">Changer de mot de passe</span>
    </a>`;

      this.profileDrodownHtml += `    <a class="myCommands w-full flex md:hidden items-center gap-2 p-2 pl-4 bg-noir-2 hover:bg-noir-2-contour">
<span class="material-icons">
list_alt
</span>
    <span class="font-semibold">Mes commandes</span>
    </a>`;
    }

    if (this.message) {
      this.profileDrodownHtml += `    <a class="restaurantMessage w-full flex md:hidden items-center gap-2 p-2 pl-4 bg-noir-2 hover:bg-noir-2-contour">
<span class="material-icons">
campaign
</span>
    <span class="font-semibold">Message du restaurant</span>
    </a>`;
    }

    this.profileDrodownHtml += `    <a [routerLink]="/logout" href="/logout" class="w-full flex items-center gap-2 p-2 pl-4 text-red-400 bg-noir-2 hover:bg-noir-2-contour">
    <span class="material-icons">
      logout
      </span>
      <span class="font-semibold">Se déconnecter</span>
    </a>`;



    this.profileDrodownHtml += `
    <p class="px-2 text-center text-[.70rem] text-left w-full bg-noir-2 text-[#696969] py-2 font-bold">Build: ${this.formatBuildDate(
      env.buildDate
    )} (#${env.lastPipeline})</p>
    `;
    this.cdr.detectChanges();

    this.clickListeners();
  }

  url(): string {
    return window.location.pathname.trim();
  }

  displayCartModal() {
    this.responsive.isMobileCartShowedSubject.next(
      !this.responsive.isMobileCartShowedSubject.value
    );
  }

  computeCartTotal(): number {
    if (!this.currentService) return -1;
    if (!this.selectedRestaurant) return -2;
    if (!this.selectedDate) return -3;
    const childId = this.currentChild ? this.currentChild.id : -1;
    const cart = this.cart.getCartFor(
      this.currentService.id,
      this.selectedRestaurant.id,
      childId,
      this.selectedDate
    );

    if (!cart) return -4;


    const adm = this.qdmService.selectedAdmissionSubject.value;
    if (!adm) {
      const total = this.cart.computeCartTotal(this.currentService.id, this.selectedRestaurant.id, childId, this.selectedDate);

      return total;
    }


    const supplementsPrices = cart
      .filter((item) => this.isExtra(item.id))
      .reduce((acc, item) => acc + item.displayedPrice * item.quantity, 0);
    return (
      adm.finalPrice * this.qdmService.groupOrderQuantitySubject.value +
      supplementsPrices
    );
  }

  countItemInCart(): number {
    if (!this.selectedDate) {
      return 0;
    }

    // foreach item in cart, count the quantity
    let count = 0;

    const cart = this.cart.getCartFor(
      this.currentService?.id || -1,
      this.selectedRestaurant?.id || -1,
      this.currentChild?.id || -1,
      this.selectedDate
    );
    if (!cart) return 0;

    cart.forEach((item) => {
      count += item.quantity;
    });

    return count;
  }

  isExtra(courseId: number): boolean {
    const rank = this.currentService?.components.find((c) =>
      c.courses.some((course) => course.id === courseId)
    );
    if (!rank) return false;

    const course = rank.courses.find((course) => course.id === courseId);
    if (!course) return false;

    return course.is_extra;
  }

  openCommandsHistory() {
    this.modal.open(ModalCommandsHistoryComponent, {}, () => {});
  }

  currency() {
    return (this.wallet?.currency || 0) / 100;
  }

  currencyFormatted() {
    return ((this.wallet?.currency || 0) / 100).toFixed(2);
  }

  displayWalletReload() {
    this.modal.open(ModalReloadWalletComponent, {}, () => {});
  }

  ngAfterViewInit() {
    document.addEventListener('keydown', (e) => {
      if ((e.ctrlKey || e.metaKey || e.altKey || e.shiftKey) && e.key === 'b') {
        const user = this.auth.userSubject.value;

        if (!user) {
          this.toast.error("Aucun compte n'est connecté.", '', {
            positionClass: 'toast-bottom-right-cart',
          });
          return;
        } else {
          this.toast.info(
            `Connecté en tant que ${user.email} (id: ${user.id})`,
            '',
            { positionClass: 'toast-bottom-right-cart' }
          );
        }
      }
    });
  }

  private clickListeners() {
    this.desktopProfile()?.nativeElement
      .querySelector('a.credit')
      ?.addEventListener('click', () => {
        this.displayWalletReload();
      });
    this.mobileProfile()?.nativeElement
      .querySelector('a.credit')
      ?.addEventListener('click', () => {
        this.displayWalletReload();
      });

    this.desktopProfile()?.nativeElement
      .querySelector('a.childPref')
      ?.addEventListener('click', () => {
        this.displayChildSettings(this.currentChild);
      });

    this.mobileProfile()?.nativeElement
      .querySelector('a.myCommands')
      ?.addEventListener('click', () => {
        this.openCommandsHistory();
      });

    this.mobileProfile()?.nativeElement
      .querySelector('a.childPref')
      ?.addEventListener('click', () => {
        this.displayChildSettings(this.currentChild);
      });

    this.mobileProfile()?.nativeElement
      .querySelector('a.restaurantMessage')
      ?.addEventListener('click', () => {
        this.showRestaurantMessage();
      });
  }

  protected displayChildSettings(child: UserChildren | null) {
    this.modal.open(
      ModalPreferencesComponent,
      {
        child: child,
        user: this.auth.userSubject.value,
      },
      () => {}
    );
  }

  private refreshCartTotal() {
      
      this.cartTotal = this.computeCartTotal();
      this.cartCount = this.countItemInCart();
      this.cdr.detectChanges();
  }

  showRestaurantMessage() {
    localStorage.removeItem('last-message-shown');
    this.modal.open(
      ModalInformationMessage,
      {
        message: this.message,
      },
      () => {}
    );
  }

  resetSelectedEnterprise() {
    this.qdmService.selectEnterprise(undefined);
  }
}
